export default {"src":"/_next/static/media/eth.b3692688.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};